import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  title: 'Title goes here'
}, getTestId('ToastWidgetContainer'));